import fetch from '@/apiconfig/index';


export function uploadFile(code,blob) {
  let param = new FormData(); //创建form对象
  param.append('file',blob);//通过append向form对象添加数据
  return fetch({
    url: '/api/admin/file/upload/'+code,
    method: 'post',
    data: param,
    headers: {'Content-Type': "multipart/form-data"},
  });
}

